import { c as _c } from "react/compiler-runtime";
import { CUSTOM_DOMAINS_SETTINGS_API } from 'modules/profile/custom-domains-settings/api/custom-domain-api';
import { CustomDomainsSettingsApiInterface } from 'modules/profile/custom-domains-settings/types/custom-domains-settings-interface';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { CountInterface, SwrPaginationInterface } from 'shared/types/pagination-interface';
import { baseFetcher } from 'shared/utils/http-client';
export function useCustomDomainsSettings(t0) {
  const $ = _c(11);
  const {
    pagination,
    limit
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== limit || $[2] !== pagination || $[3] !== user) {
    t2 = () => {
      const getKey = () => {
        if (user && pagination.startFromId === undefined && limit) {
          return `${CUSTOM_DOMAINS_SETTINGS_API}/list?pagination[limit]=${limit}`;
        } else {
          if (user && pagination.startFromId && limit) {
            return `${CUSTOM_DOMAINS_SETTINGS_API}/list?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}`;
          }
        }
      };
      const key = getKey();
      if (key) {
        return [key, RequestModuleEnum.CustomDomains];
      }
    };
    $[1] = limit;
    $[2] = pagination;
    $[3] = user;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data: customDomains,
    mutate
  } = useControlledSwr(t2, fetcher);
  let t3;
  if ($[5] !== user) {
    t3 = () => {
      if (user) {
        return [`${CUSTOM_DOMAINS_SETTINGS_API}/count?pagination[limit]`, RequestModuleEnum.CustomDomains];
      }
      return null;
    };
    $[5] = user;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    data: counter
  } = useControlledSwr(t3, baseFetcher);
  let t4;
  if ($[7] !== counter || $[8] !== customDomains || $[9] !== mutate) {
    t4 = {
      customDomains,
      mutate,
      counter
    };
    $[7] = counter;
    $[8] = customDomains;
    $[9] = mutate;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}